import * as React from "react";
import type { SVGProps } from "react";
const SvgSiren = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1ZM4.222 4.222a1 1 0 0 1 1.414 0l1.707 1.707A1 1 0 0 1 5.93 7.343L4.222 5.636a1 1 0 0 1 0-1.414Zm15.485.207a1 1 0 0 1 0 1.414l-1.5 1.5a1 1 0 1 1-1.414-1.414l1.5-1.5a1 1 0 0 1 1.414 0ZM12 10a4 4 0 0 0-4 4v3h3v-3a1 1 0 1 1 2 0v3h3v-3a4 4 0 0 0-4-4Zm6 7.172V14a6 6 0 1 0-12 0v3.172A2.999 2.999 0 0 0 4 20v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2a3 3 0 0 0-2-2.828ZM7 19a1 1 0 0 0-1 1v1h12v-1a1 1 0 0 0-1-1H7Zm-6-7a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1Zm18 0a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSiren;
